// @ts-strict-ignore
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, inject, Input, Output } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { UserFacadeService } from '../../../../store/user/user-facade.service';
import { GlobalIcon, GlobalIconColour, GlobalIconSize } from './icon.constants';

export type Margin = { top?: number; right?: number; bottom?: number; left?: number };

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
})
export class IconComponent {
  userFacadeService = inject(UserFacadeService);
  @Input() aria?: {
    controls?: string;
    expanded?: boolean;
    describedby?: string;
    label?: string;
  };
  @Input() clickable: boolean = false;
  @Input() colour: string = GlobalIconColour.Dark;
  @Input() icon: GlobalIcon | string;
  @Input() ignoreReadOnly: boolean = false;
  @Input() margin: Margin = { top: 0, right: 0, bottom: 0, left: 0 };
  @Input() padding: number;
  @Input() size: GlobalIconSize | number = GlobalIconSize.Small;
  @Input() viewBox: string;

  @Output() clickEvent = new EventEmitter();

  @HostBinding('style.marginTop.px') get marginTop() {
    return this.margin?.top;
  }
  @HostBinding('style.marginRight.px') get marginRight() {
    return this.margin?.right;
  }
  @HostBinding('style.marginBottom.px') get marginBottom() {
    return this.margin?.bottom;
  }
  @HostBinding('style.marginLeft.px') get marginLeft() {
    return this.margin?.left;
  }

  get svgStyle() {
    const style: any = {
      'width.px': this.size,
      'height.px': this.size,
      'padding.px': this.padding,
    };

    if (this.colour !== 'none') {
      style.fill = this.colour;
    }

    return style;
  }

  onClick() {
    this.clickEvent.emit();
  }
}
